export default "__VITE_ASSET__b0fcc325__"